import { useProjectStore } from '../store/projectStore';
import { rackNodeId } from '../engine/networkLogic/resolveModel';

/** Include or exclude canvas and/or rack-instance nodes from Logic. */
export function setNodesLogicExcluded(nodeIds: string[], excluded: boolean) {
  const store = useProjectStore.getState();
  const design = store.getCurrentDesign();
  if (!design || nodeIds.length === 0) return;
  const unique = Array.from(new Set(nodeIds));
  unique.forEach((nodeId) => {
    // Including a device also turns it back on (poweredOff implies exclusion).
    const patch = excluded ? { logicExcluded: true } : { logicExcluded: false, poweredOff: false };
    if (design.equipment.some((e) => e.id === nodeId)) {
      store.updateEquipmentConfig(nodeId, patch, { persistToLibrary: false });
      return;
    }
    (design.racks || []).forEach((rack) => {
      rack.equipment.forEach((item, index) => {
        if (rackNodeId(rack.id, item, index) === nodeId) {
          store.updateRackEquipmentConfig(rack.id, index, patch);
        }
      });
    });
  });
}

/** Switch devices off/on. Off excludes them from Logic simulation. */
export function setNodesPoweredOff(nodeIds: string[], poweredOff: boolean) {
  const store = useProjectStore.getState();
  const design = store.getCurrentDesign();
  if (!design || nodeIds.length === 0) return;
  const unique = Array.from(new Set(nodeIds));
  unique.forEach((nodeId) => {
    if (design.equipment.some((e) => e.id === nodeId)) {
      store.updateEquipmentConfig(nodeId, { poweredOff }, { persistToLibrary: false });
      return;
    }
    (design.racks || []).forEach((rack) => {
      rack.equipment.forEach((item, index) => {
        if (rackNodeId(rack.id, item, index) === nodeId) {
          store.updateRackEquipmentConfig(rack.id, index, { poweredOff });
        }
      });
    });
  });
}
